import React, { useState, useEffect } from "react";
import { Layout, Modal, notification, Form, Input, Select, Row, Col, Spin, FormInstance, Button,Space } from "antd";
import { SiteHeader } from "../../components";
import { addTrial } from "../../axios/api.account"
import "./trial.scss"

import { useTranslation } from "react-i18next";

const { Item } = Form;
const { TextArea } = Input;
export function Trial() {
    const { t } = useTranslation();
    const formRef = React.createRef<FormInstance>();
    var paddingWidth = (document.body.clientWidth - 1200) > 0 ? (document.body.clientWidth - 1200) / 2 : 8;
    function submitClick(){
        formRef?.current?.validateFields().then(res=>{
            addTrial(res).then(rs=>{
                notification.success({ message: t("申请成功") });
                formRef?.current?.resetFields();

            },()=>{
                //notification.error({ message: "申请失败" });
            })
        })
    }
    return (
        <Layout className="homeLayout">
            <div className="bgBox indexPadding"  style={{
                backgroundColor:"#3688F4", width: "100%", height: 64,paddingRight: paddingWidth, paddingLeft: paddingWidth
            }}>
                <Row >
                    <Col span={20}>
                        <Space size={40}>
                            <div className="indexTopNav" style={{ color: "#ffffff", fontSize: 26 }}>{t("未瓴移动设备管理平台")}</div>
                        </Space>
                    </Col>
                    <Col span={4} style={{ textAlign: "right" }}>
                        <div className="indexTopNav">
                            <Button shape="round" href="/" >{t("返回主页")}</Button>
                        </div>
                    </Col>
                </Row>
            </div>
            <div
                style={{
                    flex: "1 1 auto",
                    position: "relative",
                    overflow: "auto",
                    borderBottom: 'none',
                    backgroundColor: "#F0F2F5",
                    margin: "auto 0px"
                }}>
                <h4 className="trialTitle">{t("申请试用")}</h4>
                <div className="trialFormBox">
                    <p className="trialTitle2">{t("请您填写申请资料,我们将尽快给您回复")}</p>
                    <Form
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 12 }}
                        ref={formRef}
                        layout="horizontal"
                        onFinishFailed={() => { }}>
                        <Item label={t("姓名")} name="name" rules={[{ required: true }]} >
                            <Input></Input>
                        </Item>
                        <Item label={t("工作邮箱")} name="email" rules={[ {
                            type: 'email',
                            message: '请输入正确的邮箱!',
                        },{ required: true,}]}>
                            <Input type="email"></Input>
                        </Item>
                        <Item label={t("电话")} name="phone" >
                            <Input></Input>
                        </Item>
                        <Item label={t("部门名称")} name="organizationName" rules={[{ required: true }]}>
                            <Input></Input>
                        </Item>
                        <Item label={t("设备平台")} name="platform" >
                            <Input></Input>
                        </Item>
                        <Item label={t("详细需求")} name="detail" >
                            <TextArea rows={4} ></TextArea>
                        </Item>
                        <Item wrapperCol={{ offset: 10, span: 12 }}>
                            <Button type="primary" onClick={()=>{submitClick()}}>{t("提交")}</Button>
                        </Item>

                    </Form>
                </div>
            </div>
        </Layout>

    )

}